import { useSelector } from "react-redux"
import { myCountriesDataSelector } from "../stores";

export function useUrgentCountriesList() {
    const countries = useSelector(myCountriesDataSelector);
    const countryCodeList = countries?.filter(x => x.urgentflagfeature).map(x => x.countrycode);
    return countryCodeList ? countryCodeList : [];
}